import { getType, resolveIdentifier, types } from 'mobx-state-tree'
import Dimension, {DimensionValues} from "../../../models/Dimension";
import _ from 'lodash'
import lodash from "lodash";
export const DimensionSelectState = types.model('DimensionSelectState',{
  selectStateUuid: types.identifier,
  dimension: types.maybe(types.late(() => types.reference(Dimension))),
  selectedDimension: types.maybe(types.safeReference(DimensionValues)),
  selectedDimensions: types.maybe(types.array(types.safeReference(DimensionValues))),
}).volatile(self => ({
  notifySelect: types.function,
  notifyMultiSelect: types.function,
  notifyFilterSelect: types.funtion,
  selected: [],
  filteredDimensions: [],
  filteredDimensionValuesOnGroup: [],
})).actions( (self)=>({
  setConsumer(f){
    self.notifySelect = f
  },
  setMultiSelectConsumer(f) {
    self.notifyMultiSelect = f
  },
  setFilterConsumer(f){
    self.notifyFilterSelect = f
  },
  setDimensionFilters(dimensions){
    if(dimensions) {
      self.filteredDimensions = dimensions
    }
  },
  reset() {
    self.selected = []
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => {
      console.log("placeholder notifySelect")
    }
  },
  setSelectedDimension(selectedDimension) {
    if(lodash.isArray(selectedDimension)) {
      self.selectedDimensions = selectedDimension?.map(d => {
        return resolveIdentifier(DimensionValues, self, d?.uuid || d)
      })
      if(lodash.isEmpty(selectedDimension)){
        self.selectedDimensions = undefined
      }
      self.notifyMultiSelect(self.selectedDimensions)
    } else if(selectedDimension) {
      self.selectedDimension = selectedDimension
      console.log(self.selectedDimension)
      self.notifySelect(self.selectedDimension, self.selectStateUuid);
    }
  },
  hydrateDimensions(selectedDimension) {
    if(lodash.isArray(selectedDimension)) {
      self.selectedDimensions = selectedDimension?.map(d => {
        return resolveIdentifier(DimensionValues, self, d?.uuid || d)
      })
    } else if(selectedDimension) {
      self.selectedDimension = selectedDimension
    }
  },
  setDefaults(){
    let defaultDimensions = self.dimension.values.find(item => item?.isDefault)
    if(_.isEmpty(defaultDimensions) && self.dimension.values.length === 1){
      defaultDimensions = self.dimension.values[0] // if user has access to only one dimension, select it by default
    }
    self.setSelectedDimension(defaultDimensions)
  },
  clearSelectedDimensions(){
    self.selectedDimension = undefined
    self.selectedDimensions = undefined
  },
  filterChange(data) {
    self.selected = data;
    self.notifyFilterSelect(lodash.reduce(data, function(result, value, key) {
      const parts = value.value.split('.');
      const pushValue = parts[parts.length-1];
      const fieldName = value.value.substr(0, value.value.length - pushValue.length - 1 );
      (result[fieldName] || (result[fieldName] = [])).push(pushValue);
      return result;
    }, {}), [`dimension[${self.dimension.uuid}]`]);
  },
  getListOnGroup(groupUuid) {
    self.filteredDimensionValuesOnGroup = self.dimension?.values?.filter(item => {
      const groupUuids = item?.owner?.groupUuids;
      return groupUuids?.includes(groupUuid) || !groupUuids || groupUuids?.length === 0
    }) || [];
    if (self.selectedDimension && !self.filteredDimensionValuesOnGroup?.includes(self.selectedDimension)) {
      self.selectedDimension = self.dimension.values.find(item => item?.isDefault)
    }
  },
  setSelected(data){
    self.selected=data
  }
})).views( (self) => ({
  dimensionOptionValues() {
    let { values } = self.dimension || {};
    if(self.filteredDimensionValuesOnGroup?.length > 0 ){
      values = self.filteredDimensionValuesOnGroup
    } else {
      if(self.dimension?.type === "CONDITIONAL" && self.filteredDimensionValuesOnGroup?.length === 0){
        values = self.dimension.values.filter(item => item?.isDefault)
      }
    }
    return values.slice().sort((a,b) => a?.label?.localeCompare(b?.label)) || []
  },
  dimensionFilterOptions() {
    const {values} = self.dimension || {};
    let list = [];

    values.flatMap(value => {
      return self.filteredDimensions.flatMap(fd => {
        return fd.values.filter(f => {
          if (f.uuid === value.uuid) {
            list.push(value);
          }
        });
      });
    });

    list.sort((a, b) => a.label.localeCompare(b.label))

    return list?.map(dimension => ({
      label: dimension?.label,
      value: `dimensions.${self.dimension?.uuid}_${dimension?.uuid}`,
    })) || [];
  }
}))
